<template>
  <div>
    <Operator
      :disabled="disabled"
      :operators="mixinOperators"
      :value.sync="compareType"/>
    <AdditionalFieldInput
      v-if="$_showParametersWithOperator"
      :field="additionalField"
      :label="false"
      :loading="disabled"
      :rules="parametersRules"
      validation-prop="parameter"
      @update:value="setValue"/>
  </div>
</template>
<script>
// import AsyncValidator from 'async-validator'
import automations from 'mixins/automations.js'
import { additionalFieldsMixin } from 'mixins'
import Operator from 'components/automation/conditions/default/operator.vue'
import AdditionalFieldInput from 'components/additional fields/AdditionalFieldInput.vue'

export default {
  name: 'additionalField',
  mixins: [ automations, additionalFieldsMixin ],
  data() {
    return {
      parametersRules: null,
    }
  },
  methods: {
    setValue(value) {
      this.parameter = value?.toString()
    }
  },
  computed: {
    compareType: {
      get() {
        if (!this.value?.compareType) {
          return null
        }
        return this.value.compareType
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)
        result.compareType = newValue
        if (!this.$_showParametersWithOperator) {
          result.parameters = null
        }
        this.$emit('update:value', result)
      }
    },
    mixinOperators() {
      return this.operators || this.mixin_additionalFields.operators[this.additionalProps?.typeId] || []
    },
    additionalField: {
      get() {
        const result = this.$_.cloneDeep(this.additionalProps)
        let value = null
        if (this.value?.parameters) {
          try {
            value = JSON.parse(this.value?.parameters)
          } catch {
            this.$notice.error({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t('Tenders.ErrorConditionParams'),
              showClose: true,
              progress: true,
            })
            value = null
          }

          result.value = value[0]
          return result
        } else {
          return result
        }
      },
    },
    parameter: {
      get() {
        return this.value?.parameters
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)
        result.parameters = newValue ? JSON.stringify([newValue]) : null
        this.$emit('update:value', result)
      }
    },
  },
  components: {
    Operator,
    AdditionalFieldInput
  },
  watch: {
    compareType: {
      immediate: true,
      handler() {
        this.parametersRules = this.$_getAdditionalFieldRule(
          this.additionalProps.typeId,
          this
        )
      }
    },
    $_showParametersWithOperator: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue && !newValue) {
          this.parameter = null
        }
      }
    }
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
    additionalProps: {
      type: Object
    },
  },
}
</script>
